const frCommon = {
  nav: {
    home: 'Accueil',
    projects: 'Projets',
    services: 'Services',
    about: 'À Propos',
    contact: 'Contact',
    login: 'Connexion Employé',
  },
  hero: {
    title: 'Construire',
    titleSecond: 'des Rêves à',
    titleThird: 'Tétouan',
    subtitle: 'Promotet est une entreprise leader dans le développement immobilier à Tétouan, Maroc, spécialisée dans les propriétés résidentielles, commerciales et d\'investissement. Nous transformons les visions en réalité avec une qualité exceptionnelle et un design innovant.',
    cta: 'Explorer les Projets',
    stats: {
      projects: 'Projets Réalisés',
      years: 'Années d\'Excellence',
      clients: 'Clients Satisfaits',
    },
  },
  projects: {
    label: 'Nos Projets',
    title: 'Découvrez Nos',
    titleSecond: 'Développements Premium',
    description: 'Explorez notre portefeuille de projets immobiliers exceptionnels, chacun conçu pour offrir luxe, confort et un style de vie supérieur dans des emplacements de choix.',
    compareProjects: 'Comparer les Projets',
    showFilters: 'Afficher les Filtres',
    hideFilters: 'Masquer les Filtres',
    filterLocation: 'Emplacement',
    filterBedrooms: 'Chambres',
    filterPrice: 'Gamme de Prix',
    allLocations: 'Tous les Emplacements',
    allBedrooms: 'Toutes les Chambres',
    bedroom: 'Chambre',
    bedrooms: 'Chambres',
    resetFilters: 'Réinitialiser les Filtres',
    projectsFound: 'projets trouvés',
    noResults: 'Aucun projet ne correspond à vos filtres',
  },
  projectDetail: {
    backToProjects: 'Retour aux Projets',
    overview: {
      label: 'Aperçu du Projet',
      title: 'Le Luxe Redéfini',
      description1: 'Ce développement exceptionnel représente le summum de la vie de luxe moderne à Tétouan. Combinant architecture contemporaine et finitions premium, chaque détail a été soigneusement conçu pour offrir aux résidents une expérience de vie inégalée.',
      description2: 'Situé dans l\'un des quartiers les plus recherchés, ce projet offre un accès facile à toutes les commodités tout en offrant une retraite paisible loin de l\'agitation de la ville. Avec des installations de classe mondiale et des vues imprenables, c\'est plus qu\'une maison – c\'est un style de vie.',
      scheduleVisit: 'Planifier une Visite',
      keyFeatures: 'Caractéristiques Clés',
    },
    features: {
      units: 'Unités',
      size: 'Gamme de Tailles',
      bedrooms: 'Chambres',
      parking: 'Parking',
      security: 'Sécurité',
      delivery: 'Livraison',
      included: 'Inclus',
    },
    gallery: {
      label: 'Visite Visuelle',
      title: 'Explorez les Espaces',
    },
    amenities: {
      label: 'Équipements Premium',
      title: 'Installations de Classe Mondiale',
      description: 'Profitez d\'un style de vie exceptionnel avec notre gamme complète d\'équipements premium conçus pour votre confort et votre commodité.',
      pool: 'Piscine',
      gym: 'Centre de Fitness',
      garden: 'Jardins Paysagers',
      concierge: 'Conciergerie 24/7',
      retail: 'Espaces Commerciaux',
      playground: 'Aire de Jeux',
    },
    location: {
      label: 'Emplacement de Choix',
      title: 'Parfaitement Positionné',
      description: 'Stratégiquement situé au cœur de Tétouan, offrant un accès facile aux écoles, centres commerciaux, restaurants et principales voies de transport.',
    },
    cta: {
      title: 'Prêt à Faire de Ceci Votre Maison?',
      description: 'Contactez notre équipe de vente dès aujourd\'hui pour planifier une visite privée et en savoir plus sur les unités disponibles et les plans de paiement.',
      contact: 'Nous Contacter',
      download: 'Télécharger la Brochure',
    },
  },
  services: {
    label: 'Ce Que Nous Offrons',
    title: 'Solutions Immobilières',
    titleSecond: 'Complètes',
    description: 'Des développements résidentiels aux espaces commerciaux et opportunités d\'investissement, nous fournissons des solutions immobilières de bout en bout adaptées à vos besoins.',
    residential: {
      title: 'Développement Résidentiel',
      description: 'Créer des espaces de vie modernes qui combinent confort, style et fonctionnalité pour les familles et les particuliers.',
      feature1: 'Appartements et villas de luxe',
      feature2: 'Équipements et installations modernes',
      feature3: 'Emplacements privilégiés à Tétouan',
      feature4: 'Principes de conception durable',
    },
    commercial: {
      title: 'Propriétés Commerciales',
      description: 'Développer des espaces commerciaux stratégiques conçus pour améliorer la croissance des entreprises et l\'expérience client.',
      feature1: 'Espaces de vente et bureaux',
      feature2: 'Emplacements à fort trafic',
      feature3: 'Aménagements flexibles',
      feature4: 'Infrastructure moderne',
    },
    investment: {
      title: 'Opportunités d\'Investissement',
      description: 'Offrir des options d\'investissement immobilier lucratives avec des rendements solides et une appréciation de la valeur à long terme.',
      feature1: 'Potentiel de ROI élevé',
      feature2: 'Options de portefeuille diversifiées',
      feature3: 'Analyse de marché experte',
      feature4: 'Processus transparents',
    },
    process: {
      title: 'Notre Processus de Développement',
      step1: {
        title: 'Consultation',
        description: 'Comprendre vos besoins et votre vision',
      },
      step2: {
        title: 'Planification',
        description: 'Conception détaillée et stratégie de développement',
      },
      step3: {
        title: 'Construction',
        description: 'Exécution de qualité avec des équipes expertes',
      },
      step4: {
        title: 'Livraison',
        description: 'Remise et support continu',
      },
    },
  },
  about: {
    label: 'À Propos de Promotet',
    title: 'Excellence dans le Développement Immobilier',
    description: 'Avec plus de 15 ans d\'expérience, Promotet s\'est établi comme un nom de confiance sur le marché immobilier de Tétouan. Nous nous engageons à créer des propriétés exceptionnelles qui améliorent les communautés et offrent une valeur durable.',
    number: '15',
    numberText: 'Années de transformation du paysage de Tétouan avec des développements immobiliers innovants qui établissent de nouvelles normes de qualité et de design.',
    cta: 'En Savoir Plus',
    story: {
      title: 'Notre Histoire',
      paragraph1: 'Fondée en 2008, Promotet a commencé avec une vision simple : transformer le paysage immobilier de Tétouan grâce à un design innovant et une qualité exceptionnelle. Au fil des ans, nous sommes passés d\'une petite entreprise de développement à l\'une des sociétés immobilières les plus respectées de la région.',
      paragraph2: 'Notre succès repose sur une base d\'intégrité, d\'expertise et d\'une compréhension approfondie des besoins de nos clients. Chaque projet que nous entreprenons reflète notre engagement envers l\'excellence et notre passion pour créer des espaces qui améliorent la vie.',
    },
    mission: {
      title: 'Notre Mission',
      paragraph1: 'Nous nous consacrons au développement de propriétés qui non seulement répondent aux normes les plus élevées de qualité et de design, mais contribuent également positivement aux communautés que nous servons. Notre mission est de créer des espaces durables et innovants qui résistent à l\'épreuve du temps.',
      paragraph2: 'Grâce à une planification minutieuse, une exécution experte et un engagement continu envers nos clients, nous nous efforçons de dépasser les attentes et de fournir une valeur exceptionnelle dans chaque projet que nous entreprenons.',
    },
    values: {
      title: 'Nos Valeurs Fondamentales',
      value1: {
        title: 'Intégrité',
        description: 'Nous menons nos affaires avec honnêteté, transparence et pratiques éthiques dans chaque interaction.',
      },
      value2: {
        title: 'Innovation',
        description: 'Nous adoptons de nouvelles idées et technologies pour créer des solutions immobilières de pointe.',
      },
      value3: {
        title: 'Excellence',
        description: 'Nous nous engageons à fournir la plus haute qualité dans tous les aspects de notre travail.',
      },
    },
  },
  testimonials: {
    label: 'Témoignages Clients',
    title: 'Ce Que Nos',
    titleSecond: 'Clients Disent',
  },
  contact: {
    title: 'Contactez-Nous',
    subtitle: 'Prêt à commencer votre parcours immobilier ? Contactez-nous aujourd\'hui pour discuter de votre projet ou opportunité d\'investissement.',
    form: {
      title: 'Envoyez-nous un Message',
    },
    name: 'Votre Nom',
    email: 'Adresse Email',
    phone: 'Numéro de Téléphone',
    message: 'Votre Message',
    submit: 'Envoyer le Message',
    sending: 'Envoi en cours...',
    success: 'Merci ! Nous vous contacterons bientôt.',
    error: 'Une erreur s\'est produite. Veuillez réessayer.',
    info: {
      title: 'Informations de Contact',
      address: 'Adresse',
      addressText: 'Avenue Mohammed V, Tétouan 93000, Maroc',
      phone: 'Téléphone',
      phoneText: '+212 539 123 456',
      email: 'Email',
      emailText: 'contact@promotet.ma',
    },
  },
  footer: {
    description: 'Votre partenaire de confiance dans le développement immobilier de luxe en Belgique.',
    quickLinks: 'Liens Rapides',
    services: 'Services',
    contact: 'Contactez-nous',
    rights: 'Tous droits réservés.',
    privacy: 'Politique de Confidentialité',
    terms: 'Conditions Générales',
  },
  compare: {
    label: 'OUTIL DE COMPARAISON',
    title: 'Comparer les Projets',
    description: 'Sélectionnez jusqu\'à 3 projets pour comparer leurs caractéristiques, prix et commodités côte à côte. Prenez une décision éclairée pour votre investissement.',
    selectProjects: 'Sélectionner les Projets à Comparer',
    selectDescription: 'Choisissez jusqu\'à 3 projets de notre portfolio',
    comparison: 'Comparaison',
    viewDetails: 'Voir les Détails',
    selectProject: 'Sélectionner le Projet',
    noProjects: 'Aucun Projet Sélectionné',
    noProjectsDescription: 'Veuillez sélectionner au moins un projet ci-dessus pour commencer la comparaison.',
    browseProjects: 'Parcourir Tous les Projets',
    features: {
      price: 'Gamme de Prix',
      location: 'Emplacement',
      units: 'Total des Unités',
      size: 'Taille de l\'Unité',
      bedrooms: 'Chambres',
      parking: 'Parking',
      security: 'Sécurité',
      delivery: 'Livraison',
      included: 'Inclus',
    },
  },
  privacy: {
    title: 'Politique de Confidentialité',
    lastUpdated: 'Dernière mise à jour : Janvier 2025',
    intro: {
      title: 'Introduction',
      content: 'Chez LuxEstate, nous nous engageons à protéger votre vie privée et à assurer la sécurité de vos informations personnelles. Cette Politique de Confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous visitez notre site web ou utilisez nos services.',
    },
    collect: {
      title: 'Informations que Nous Collectons',
      content: 'Nous collectons les informations que vous nous fournissez directement, notamment :',
      item1: 'Informations d\'identification personnelle (nom, adresse e-mail, numéro de téléphone)',
      item2: 'Préférences immobilières et critères de recherche',
      item3: 'Enregistrements de communication et correspondance',
      item4: 'Données techniques telles que l\'adresse IP, le type de navigateur et les informations sur l\'appareil',
    },
    use: {
      title: 'Comment Nous Utilisons Vos Informations',
      content: 'Nous utilisons les informations que nous collectons pour :',
      item1: 'Fournir et améliorer nos services immobiliers',
      item2: 'Communiquer avec vous au sujet des propriétés et services',
      item3: 'Vous envoyer des communications marketing (avec votre consentement)',
      item4: 'Analyser l\'utilisation du site web et améliorer l\'expérience utilisateur',
      item5: 'Respecter les obligations légales et protéger nos droits',
    },
    protection: {
      title: 'Protection des Données',
      content: 'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos informations personnelles contre l\'accès non autorisé, la modification, la divulgation ou la destruction. Cependant, aucune méthode de transmission sur Internet n\'est sécurisée à 100%, et nous ne pouvons garantir une sécurité absolue.',
    },
    cookies: {
      title: 'Cookies et Suivi',
      content: 'Nous utilisons des cookies et des technologies de suivi similaires pour améliorer votre expérience de navigation, analyser le trafic du site et personnaliser le contenu. Vous pouvez contrôler les paramètres des cookies via les préférences de votre navigateur.',
    },
    thirdParty: {
      title: 'Services Tiers',
      content: 'Nous pouvons partager vos informations avec des prestataires de services tiers de confiance qui nous aident à exploiter notre site web et à mener nos activités. Ces parties sont tenues de garder vos informations confidentielles et de les utiliser uniquement aux fins que nous spécifions.',
    },
    rights: {
      title: 'Vos Droits',
      content: 'En vertu du RGPD et des lois applicables sur la protection des données, vous avez le droit de :',
      item1: 'Accéder à vos données personnelles',
      item2: 'Corriger les données inexactes ou incomplètes',
      item3: 'Demander la suppression de vos données',
      item4: 'Vous opposer ou restreindre le traitement de vos données',
    },
    contact: {
      title: 'Nous Contacter',
      content: 'Si vous avez des questions concernant cette Politique de Confidentialité ou nos pratiques en matière de données, veuillez nous contacter :',
    },
  },
  terms: {
    title: 'Conditions Générales',
    lastUpdated: 'Dernière mise à jour : Janvier 2025',
    intro: {
      title: 'Introduction',
      content: 'Bienvenue chez LuxEstate. Ces Conditions Générales régissent votre utilisation de notre site web et de nos services. En accédant ou en utilisant notre site web, vous acceptez d\'être lié par ces conditions. Si vous n\'êtes pas d\'accord avec une partie de ces conditions, veuillez ne pas utiliser nos services.',
    },
    acceptance: {
      title: 'Acceptation des Conditions',
      content: 'En accédant et en utilisant ce site web, vous acceptez et convenez d\'être lié par les termes et dispositions de cet accord. De plus, lors de l\'utilisation de services particuliers, vous serez soumis à toutes les directives ou règles applicables à ces services.',
    },
    services: {
      title: 'Utilisation des Services',
      content: 'Vous acceptez d\'utiliser nos services uniquement à des fins légales et conformément à ces Conditions. Vous acceptez de ne pas :',
      item1: 'Utiliser les services d\'une manière qui viole toute loi ou réglementation applicable',
      item2: 'Adopter une conduite qui restreint ou empêche l\'utilisation des services par quiconque',
      item3: 'Tenter d\'obtenir un accès non autorisé à toute partie du site web',
      item4: 'Utiliser un système automatisé pour accéder aux services d\'une manière qui envoie plus de requêtes qu\'un humain ne peut raisonnablement produire',
    },
    property: {
      title: 'Informations sur les Propriétés',
      content: 'Toutes les informations sur les propriétés, images et descriptions fournies sur ce site web sont à titre informatif uniquement. Bien que nous nous efforcions d\'assurer l\'exactitude, nous ne garantissons pas que toutes les informations sont complètes, exactes ou à jour. La disponibilité et les prix des propriétés sont sujets à changement sans préavis.',
    },
    intellectual: {
      title: 'Propriété Intellectuelle',
      content: 'Le contenu de ce site web, y compris le texte, les graphiques, les logos, les images et les logiciels, est la propriété de LuxEstate ou de ses fournisseurs de contenu et est protégé par les lois internationales sur le droit d\'auteur. Vous ne pouvez pas reproduire, distribuer ou créer des œuvres dérivées sans notre autorisation écrite expresse.',
    },
    liability: {
      title: 'Limitation de Responsabilité',
      content: 'LuxEstate ne sera pas responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs résultant de votre utilisation ou de votre incapacité à utiliser les services. Notre responsabilité totale ne dépassera pas le montant que vous avez payé, le cas échéant, pour accéder à nos services.',
    },
    indemnification: {
      title: 'Indemnisation',
      content: 'Vous acceptez d\'indemniser et de dégager de toute responsabilité LuxEstate et ses affiliés, dirigeants, agents et employés de toute réclamation ou demande, y compris les honoraires d\'avocat raisonnables, faite par un tiers en raison de ou découlant de votre violation de ces Conditions ou de votre violation de toute loi ou des droits d\'un tiers.',
    },
    modifications: {
      title: 'Modifications des Conditions',
      content: 'Nous nous réservons le droit de modifier ces Conditions à tout moment. Nous vous informerons de tout changement en publiant les nouvelles Conditions sur cette page et en mettant à jour la date de "Dernière mise à jour". Votre utilisation continue des services après de telles modifications constitue votre acceptation des Conditions mises à jour.',
    },
    law: {
      title: 'Loi Applicable',
      content: 'Ces Conditions seront régies et interprétées conformément aux lois de la Belgique, sans égard à ses dispositions en matière de conflit de lois. Tout litige découlant de ces Conditions sera soumis à la juridiction exclusive des tribunaux de Bruxelles, Belgique.',
    },
    contact: {
      title: 'Informations de Contact',
      content: 'Si vous avez des questions concernant ces Conditions Générales, veuillez nous contacter :',
    },
  },
};

export default frCommon;
